import { useEffect, useState } from "react";

const CommonMessage=({text})=>{
    const [show, setShow] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="alert alert-success mt-3">
      {/* {text} */}
       {typeof text === "object"
                ? JSON.stringify(text)
                : text}
    </div>
  );
}
export default CommonMessage;